import axiosInstance from "@/shared/api/axiosInstance.js";

export const generateTelegramCode = () => {
    return axiosInstance.post("/site/profile/telegram/generate");
};
